import { type LoaderFunction } from 'react-router';
import store from '../../store';
import { loadTimeSlotsData } from '../../reducers/timeslots/timeSlotsReducer';
import services from '../../services';
import { updatePage } from '../../reducers/app/appReducer';
import { clearContactState } from '../../reducers/contact/contactReducer';
import { loadDataForSelectedService } from './loaderHelper';
import { viewContext } from '../middleware/context';

const loader: LoaderFunction = async ({ context }) => {
  const view = context.get(viewContext);
  const selectedState = store.getState().app.selected;
  const from = store.getState().timeSlots.from;
  const selectedTimeSlot =
    selectedState.timeSlot || selectedState.replacementService.timeSlot;
  const page = store.getState().app.page;

  if (page === 'contact' && selectedTimeSlot) {
    // clear contact state and reserved time slot on back navigation
    store.dispatch(clearContactState());
    services.timeSlot.clearReservedTimeSlot(selectedTimeSlot.id);
  }
  store.dispatch(updatePage('timeslots'));

  await loadDataForSelectedService(view);
  await store.dispatch(loadTimeSlotsData({ from }));
};

export default loader;
